import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCursor1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"cursor-1, arrow"} maskId="square-filled-radius-0-stroke-1-IconCursor1"><path d="M23.3846 9.81553L2.14453 2.14551L9.81455 23.3856L13.9446 13.9455L23.3846 9.81553Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCursor1;
